import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import rootReducers from "../features/rootReducers/rootReducers";

export const store = configureStore({
 reducer: rootReducers,
});